import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import * as moment from 'moment';
import {ActivatedRoute, Router} from '@angular/router';
import {DataManagementService} from '../../services/data-management.service';
import {BiddingService} from '../../services/bidding.service';
import {EpasUtilService} from '../../services/epas-util.service';
import {ToastrService} from 'ngx-toastr';
import {RoundNameConstants} from '../../round-name-constants';
import Swal from 'sweetalert2';
import {HttpClient} from '@angular/common/http';
import {University} from '../../model/university';
import {AuthenticationService} from '../../services/authentication.service';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Constants} from '../../constants';

@Component({
    selector: 'app-practice-round',
    templateUrl: './practice-round.component.html',
    styleUrls: ['./practice-round.component.css']
})
export class PracticeRoundComponent implements OnInit, OnDestroy {
    @ViewChild('universityWiseStudentsList') universityWiseStudentsList: TemplateRef<any>;
    @ViewChild('changeDreamUniversityModal') changeDreamUniversityModal: TemplateRef<any>;
    title = 'Bidding Practice Round';
    studentCgpa;
    greScore;
    gmatScore;
    studentWorkExperience;
    enableDreamUniversity = false;
    enablePreviousRoundPreferences = false;
    enableOptOut = false;
    timeToEnd;
    timeToStart;
    roundSettingsTimer;
    oneSecondTimer;
    inRandomTime = false;
    isRoundEnded = false;
    isRoundYetToStart = false;
    isDataReady = false;
    isStudentRoundDataReady = false;
    isDataFetched = false;
    isRoundExist = false;
    term;
    errorMessage: string = undefined;
    listErrorMessage: string = undefined;
    currentTime;
    currentTimeStr: string;
    route;
    startTime;
    totalUniversitiesCount;
    startTimeStr: string;
    endTime;
    endTimeStr: string;
    refID;
    finalEndTime;
    courses;
    activeRoundLink: string;
    activeRound: string;
    public modalReference: NgbModalRef;
    selectedUniversity = undefined;
    listOfStudents = undefined;
    universities;
    dreamUniversity;
    changedDreamUniversity;
    isUniversityAllotted = false;
    isStudentOptedOutFromExchange = false;
    expectedUniversity;
    roundName = 'Practice Bidding Round';
    optingOut = false;

    sourceUniversities: University[] = [];
    targetUniversities: University[] = [];

    constructor(private dmService: DataManagementService,
                private biddingService: BiddingService,
                private router: Router,
                private utilService: EpasUtilService,
                private authService: AuthenticationService,
                private activatedRoute: ActivatedRoute,
                private modal: NgbModal,
                private toastr: ToastrService,
                private http: HttpClient) {
    }

    createOrUpdatePreferences(e) {
        for ( let i = 0; i < e.items.length; i++) {
            const obj = e.items[i];
            if (this.studentCgpa < obj.min_cgpa) {
                this.toastr.warning('Failed to update the selected universities list because you do not meet' +
                    ' min. CGPA requirement of the university. ', 'Failed');
                this.getRoundData();
                return;
            }
            if (this.studentWorkExperience < obj.min_work_experience) {
                this.toastr.warning('Failed to update the selected universities list because you do not meet' +
                    ' min. work experience (in months) requirement of the university. ', 'Failed');
                this.getRoundData();
                return;
            }
        }
        const toBeModifiedData = {
            outgoing_student_id: JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id,
            outgoing_round_id: JSON.parse(localStorage.getItem('epas_user')).term.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND]
                .outgoing_round_id,
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id,
            cgpa: this.studentCgpa,
            gre_score: this.greScore,
            gmat_score: this.gmatScore,
            work_experience: this.studentWorkExperience,
            universities: []
        };
        for (let i = 0; i < this.targetUniversities.length; i++) {
            const eachUniversity = this.targetUniversities[i];
            toBeModifiedData.universities.push({
                university_id: eachUniversity.university_id,
                preference_rank: (i + 1)
            });
        }
        this.dmService.createOrUpdateStudentPreferences(toBeModifiedData).subscribe(createOrUpdateResponse => {
            if (createOrUpdateResponse.status === 'success') {
                this.toastr.success('Successfully updated the selected universities list.', 'Success');
            } else if (createOrUpdateResponse.status === 'fail') {
                if (createOrUpdateResponse.hasOwnProperty('message') && createOrUpdateResponse.message !== null &&
                    createOrUpdateResponse.message !== '' && createOrUpdateResponse.message !== undefined) {
                    this.toastr.warning(createOrUpdateResponse.message, 'Failed');
                } else {
                    this.toastr.warning('Failed to add to the selected universities list.', 'Failed');
                }
            }
            this.getRoundData();
        },
        error => {
            this.toastr.error( 'Server Error');
        });
    }

    deletePreferences(e) {
        const deletedUniversities = [];
        for (let i = 0; i < e.items.length; i++) {
            deletedUniversities.push(e.items[i].id);
        }
        const toBeModifiedData = {
            outgoing_student_id: JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id,
            outgoing_round_id: JSON.parse(localStorage.getItem('epas_user')).term.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND]
                .outgoing_round_id,
            delete_universities: deletedUniversities,
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id,
            universities: []
        };
        for (let i = 0; i < this.targetUniversities.length; i++) {
            const eachUniversity = this.targetUniversities[i];
            toBeModifiedData.universities.push({
                id: eachUniversity.id,
                preference_rank: (i + 1)
            });
        }
        this.dmService.deleteStudentPreferences(toBeModifiedData).subscribe(deleteResponse => {
            if (deleteResponse.status === 'success') {
                this.toastr.success('Successfully updated the selected university list.', 'Success');
            } else if (deleteResponse.status === 'fail') {
                if (deleteResponse.hasOwnProperty('message') && deleteResponse.message !== null &&
                    deleteResponse.message !== '' && deleteResponse.message !== undefined) {
                    this.toastr.warning('Failed to remove from the selected university list because '
                        + deleteResponse.message, 'Failed');
                } else {
                    this.toastr.warning('Failed to remove from the selected university list.', 'Failed');
                }
            }
            this.getRoundData();
        });
    }
    moveToTarget (e) {
        console.log(e);
        const toBeModifiedData = {
            outgoing_student_id: JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id,
            outgoing_round_id: JSON.parse(localStorage.getItem('epas_user')).term.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND]
                .outgoing_round_id,
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id,
            universities: []
        };
        for (let i = 0; i < this.targetUniversities.length; i++) {
            const eachUniversity = this.targetUniversities[i];
            toBeModifiedData.universities.push({
                university_id: eachUniversity.university_id,
                preference_rank: (i + 1)
            });
        }
        this.dmService.createOrUpdateStudentPreferences(toBeModifiedData).subscribe(result => {
        });
    }

    getStudentList(university) {
        this.selectedUniversity = university;
        const roundId = JSON.parse(localStorage.getItem('epas_user')).term.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND]
            .outgoing_round_id;
        const parameter = roundId + '/' + this.selectedUniversity.university_id;
        this.modalReference = this.modal.open(this.universityWiseStudentsList, {size: 'lg', backdrop: 'static', keyboard: false});
        this.dmService.javaGetDataCallByParameter(Constants.GET_UNIVERSITY_WISE_STUDENT_LIST, parameter)
            .subscribe( results => {
                if ( results.status === 'success' ) {
                    this.listOfStudents = results.data;
                    if ( this.listOfStudents.length === 0 ) {
                        this.listErrorMessage = 'There are no students for this university.';
                    }
                }
                if ( results.status === 'fail' ) {
                    this.listErrorMessage = results.message;
                }
            }, errors => {
                console.log(errors);
                this.listErrorMessage = 'Server Error';
            });
    }

    getDateTime(dateTime): string {
        if (dateTime === undefined || dateTime === null || dateTime === '' || dateTime === 'undefined') {
            return '';
        }
        return moment(dateTime).format('Do MMM YYYY , hh:mm a');
    }

    getRoundData(): void {
        if (JSON.parse(localStorage.getItem('epas_user')).term !== null) {
            const loggedInStudent = JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id;
            if (JSON.parse(localStorage.getItem('epas_user')).term.rounds.hasOwnProperty(RoundNameConstants.PRACTICE_BIDDING_ROUND)) {
                const roundId = JSON.parse(localStorage.getItem('epas_user')).term.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND]
                    .outgoing_round_id;
                const focusedElement: HTMLElement = <HTMLElement>document.activeElement;
                this.dmService.getStaticDataForRound(loggedInStudent, roundId)
                    .subscribe(
                        details => {
                            this.isRoundExist = true;
                            this.isUniversityAllotted = false;
                            if (details.status === 'success') {
                                this.universities = details.data.all_universities;
                                this.dreamUniversity = details.data.dream_university;
                                this.isUniversityAllotted = details.data.is_university_allotted;
                                this.isStudentOptedOutFromExchange = details.data.is_student_opted_out;
                                this.sourceUniversities = details.data.available_universities;
                                this.expectedUniversity = details.data.expected_university;
                                this.targetUniversities = details.data.selected_universities;
                                if (focusedElement.id !== undefined && focusedElement.id !== '' && focusedElement.id !== null) {
                                    window.setTimeout(function () {
                                        document.getElementById(focusedElement.id).focus();
                                    }, 0);
                                }
                                this.isStudentRoundDataReady = true;
                            } else if (details.status === 'fail' && details.name === 'SequelizeConnectionError') {
                                Swal({type: 'warning', title: 'There\'s a problem with your internet connection'});
                            } else if (details.status === 'fail') {
                                this.errorMessage = details.data.message;
                            }
                        },
                        error => {
                            console.log(error);
                            this.errorMessage = 'Server Error';
                            this.isStudentRoundDataReady = true;
                            this.toastr.warning('Something is not right. Please refresh and reach out to contact team if' +
                                ' the issue persists', 'Fail');
                        });
            } else {
                this.isRoundExist = false;
                this.isStudentRoundDataReady = true;
            }
        }
    }
    refreshRoundSettings() {
        if (this.utilService.term !== undefined && this.utilService.term !== null && this.utilService.term !== '') {
            if (this.utilService.term.hasOwnProperty('rounds') && this.utilService.term.rounds
                .hasOwnProperty(RoundNameConstants.PRACTICE_BIDDING_ROUND)) {
                this.startTime = moment(this.utilService.term.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND].start_time)
                    .utcOffset('+05:30');
                this.startTimeStr = this.startTime.format('DD-MMM-YYYY, hh:mm A');
                this.endTime = moment(this.utilService.term.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND].end_time).utcOffset('+05:30');
                this.endTimeStr = this.endTime.format('DD-MMM-YYYY, hh:mm A');
                this.finalEndTime = moment(this.utilService.term.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND].end_time)
                    .utcOffset('+05:30').add(this.refID, 'seconds');
                this.isRoundExist = true;
                if (this.currentTime > this.finalEndTime) {
                    this.isRoundEnded = true;
                } else if (this.currentTime < this.startTime) {
                    this.isRoundEnded = false;
                    this.isRoundYetToStart = true;
                    this.timeToStart = moment.duration(this.startTime - this.currentTime);
                } else {
                    this.isRoundEnded = false;
                    this.isRoundYetToStart = false;
                    this.timeToEnd = moment.duration(this.endTime - this.currentTime);
                }
            }
        }
    }

    getRoundTimings(): void {
        if (JSON.parse(localStorage.getItem('epas_user')).term !== null) {
            const loggedInStudent = JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id;
            if (JSON.parse(localStorage.getItem('epas_user')).term.hasOwnProperty('rounds') &&
                JSON.parse(localStorage.getItem('epas_user')).term.rounds.hasOwnProperty(RoundNameConstants.PRACTICE_BIDDING_ROUND)) {
                this.utilService.refreshTerm(loggedInStudent).subscribe(roundDetails => {
                    if (roundDetails.status === 'success') {
                        if (roundDetails.data != null) {
                            this.utilService.term = {rounds: roundDetails.data.rounds};
                            this.utilService.term.currentTime = roundDetails.data.current_time;
                            this.utilService.term.registration_start_time = roundDetails.data.term.registration_start_time;
                            this.utilService.term.registration_end_time = roundDetails.data.term.registration_end_time;
                            this.studentCgpa = roundDetails.data.cgpa;
                            this.greScore = roundDetails.data.gre_score;
                            this.gmatScore = roundDetails.data.gmat_score;
                            this.studentWorkExperience = roundDetails.data.work_experience;

                            this.currentTime = moment(roundDetails.data.current_time).utcOffset('+05:30');
                            this.startTime = moment(roundDetails.data.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND].start_time)
                                .utcOffset('+05:30');
                            this.startTimeStr = this.startTime.format('DD-MMM-YYYY, hh:mm A');
                            this.endTime = moment(roundDetails.data.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND].end_time)
                                .utcOffset('+05:30');
                            this.endTimeStr = this.endTime.format('DD-MMM-YYYY, hh:mm A');
                            this.finalEndTime = moment(roundDetails.data.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND].end_time)
                                .utcOffset('+05:30').add(this.refID, 'seconds');
                            this.totalUniversitiesCount = roundDetails.data.total_university_count;
                        }
                        this.isRoundExist = true;
                        const user = JSON.parse(localStorage.getItem('epas_user'));
                        user.term.rounds = roundDetails.data.rounds;
                        this.authService.setUser(JSON.stringify(user));
                    } else if (roundDetails.status === 'fail' && roundDetails.name === 'SequelizeConnectionError') {
                        Swal({type: 'error', title: 'There\'s a problem with your internet connection'});
                    } else if (roundDetails.status === 'fail') {
                        Swal({type: 'warning', title: 'Application updated', text: roundDetails.data.message});
                        this.errorMessage = roundDetails.data.message;
                    }
                }, error => {
                    this.toastr.warning('Something is not right. Please refresh and reach out to contact team if' +
                        ' the issue persists', 'Fail');
                    console.log(error);
                    this.isDataReady = true;
                    this.errorMessage = 'Server Error';
                });
            } else {
                this.isRoundExist = false;
                this.isDataReady = true;
            }
        }
    }
	disableDreamChange(): boolean {
		const currentRoundId = JSON.parse(localStorage.getItem('epas_user')).term.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND]
			.outgoing_round_id;
		return (this.dreamUniversity !== null && this.dreamUniversity.hasOwnProperty('outgoing_round_id') && this.dreamUniversity.outgoing_round_id !== currentRoundId);
	}

    changeDreamUniversity(e) {
		e.preventDefault();
        const that = this;
        let changeDreamUniversityResponse;
        const body = {
            outgoing_student_id: JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id,
            outgoing_round_name_id: RoundNameConstants.PRACTICE_BIDDING_ROUND,
            outgoing_round_id: JSON.parse(localStorage.getItem('epas_user')).term.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND]
                .outgoing_round_id,
            university_id: this.changedDreamUniversity.university_id,
            outgoing_term_id: JSON.parse(localStorage.getItem('epas_user')).term.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND]
                .outgoing_term_id
        };
        Swal({
            type: 'question',
            title: 'Confirm',
			html: 'Do you want to change your dream university?',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.javaPostDataCall(body, Constants.CHANGE_DREAM_UNIVERSITY).subscribe(data => {
                        changeDreamUniversityResponse = data;
                        resolve(changeDreamUniversityResponse);
                    }, error => {
                        changeDreamUniversityResponse = error;
                        reject(changeDreamUniversityResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (changeDreamUniversityResponse.status === 'success') {
                    if (changeDreamUniversityResponse.hasOwnProperty('message')) {
						that.toastr.success('Successfully changed dream university.', 'Success');
                    }
                    that.closeModal();
                    that.getRoundData();
                } else if (changeDreamUniversityResponse.status === 'fail') {
                    if (changeDreamUniversityResponse.hasOwnProperty('message')) {
                        that.toastr.error(changeDreamUniversityResponse.message, 'Failed');
                    } else {
						that.toastr.error('Unable to change dream university, Please contact support team.', 'Failed');
                    }
                }
            }
        }, function (cancel) {
            console.log(cancel);
        }).catch(function (error) {
            console.log(error);
        });
    }

    optOutFromExchange() {
        const that = this;
        let optOutResponse;
        const body = {
            outgoing_student_id: JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id,
            outgoing_round_name_id: RoundNameConstants.PRACTICE_BIDDING_ROUND,
            outgoing_round_id: JSON.parse(localStorage.getItem('epas_user')).term.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND]
                .outgoing_round_id,
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id,
            outgoing_term_id: JSON.parse(localStorage.getItem('epas_user')).term.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND]
                .outgoing_term_id
        };
        Swal({
            type: 'question',
            title: 'Confirm',
            html: 'Do you want to <span style="font-weight: bold">Opt-out</span> from the' +
                ' <span style="font-weight: bold">Exchange Process</span>?<br>' +
                ' You will not be able to <span style="font-weight: bold">participate</span> in any <span style="font-weight: bold">' +
                'further rounds</span> and <span style="font-weight: bold">fine would be applicable as per conveyed by OIA</span>',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                that.optingOut = true;
                return new Promise(function (resolve, reject) {
                    that.dmService.javaPostDataCall(body, Constants.OPT_OUT_FROM_EXCHANGE).subscribe(data => {
                        optOutResponse = data;
                        resolve(optOutResponse);
                    }, error => {
                        optOutResponse = error;
                        reject(optOutResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (optOutResponse.status === 'success') {
                    that.toastr.success('Successfully Opted-out from the Exchange Process.', 'Success');
                    that.getRoundData();
                } else if (optOutResponse.status === 'fail') {
                    if (optOutResponse.hasOwnProperty('message') && optOutResponse.message !== '' &&
                        optOutResponse.message !== null && optOutResponse.message !== undefined) {
                        that.toastr.error(optOutResponse.message, 'Fail');
                    } else {
                        that.toastr.error('Unable to opt-out from the exchange process, Please contact support team.', 'Fail');
                    }
                }
                that.optingOut = false;
            }
        }, function (cancel) {
            console.log(cancel);
        }).catch(function (error) {
            console.log(error);
        });
    }

    closeModal(): void {
        this.listErrorMessage = undefined;
        this.selectedUniversity = undefined;
        this.listOfStudents = undefined;
        this.changedDreamUniversity = undefined;
        this.modalReference.close();
    }

    openChangeDreamUniversityModal(): void {
        this.modalReference = this.modal.open(this.changeDreamUniversityModal, {size: 'lg', backdrop: 'static', keyboard: false});
    }

    ngOnInit() {
        this.getRoundData();
        this.getRoundTimings();
        if (this.utilService.term && this.utilService.getNextActiveRoundRouterLink() !== undefined) {
            this.activeRoundLink = this.utilService.getNextActiveRoundRouterLink().split('#')[0];
            this.activeRound = this.utilService.getNextActiveRoundRouterLink().split('#')[1];
        }
        if (JSON.parse(localStorage.getItem('epas_user')).term !== null && this.utilService.term !== undefined) {
            if (this.utilService.term.hasOwnProperty('rounds') && this.utilService.term.rounds.hasOwnProperty(
                RoundNameConstants.PRACTICE_BIDDING_ROUND)) {
                this.isRoundExist = true;
                this.startTime = moment(this.utilService.term.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND].start_time)
                    .utcOffset('+05:30');
                this.startTimeStr = this.startTime.format('DD-MMM-YYYY, hh:mm A');
                this.endTime = moment(this.utilService.term.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND].end_time).utcOffset('+05:30');
                this.endTimeStr = this.endTime.format('DD-MMM-YYYY, hh:mm A');
                this.finalEndTime = moment(this.utilService.term.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND].end_time)
                    .utcOffset('+05:30').add(this.refID, 'seconds');
            }
        }
        this.route = this.router.url;
        // this.activatedRoute.url.subscribe(url => console.log(url[0].path));
        this.roundSettingsTimer = setInterval(() => {
            this.errorMessage = undefined;
            if (this.route.indexOf('/bidding-rounds/practice-round') !== -1) {
                this.refreshRoundSettings();
            }
            if (this.route.indexOf('/bidding-rounds/practice-round') !== -1 && !this.isRoundEnded && !this.isRoundYetToStart
                && this.isRoundExist && !this.isUniversityAllotted) {
                this.getRoundData();
            }
            if (this.route.indexOf('/bidding-rounds/practice-round') === -1) {
                clearInterval(this.roundSettingsTimer);
            }
        }, 30000);
        this.oneSecondTimer = setInterval(() => {
            if (this.utilService.term && this.utilService.getNextActiveRoundRouterLink() !== undefined) {
                this.activeRoundLink = this.utilService.getNextActiveRoundRouterLink().split('#')[0];
                this.activeRound = this.utilService.getNextActiveRoundRouterLink().split('#')[1];
            }
            this.refreshRoundSettings();
            if (this.route.indexOf('/bidding-rounds/practice-round') !== -1 && this.isRoundExist) {
                this.currentTime = moment(this.currentTime).utcOffset('+05:30').add({'seconds': 1});
                this.currentTimeStr = this.currentTime.format('DD-MMM-YYYY, hh:mm:ss A');
                this.inRandomTime = this.currentTime > this.endTime && this.currentTime <= this.finalEndTime;
                if (this.currentTime > this.finalEndTime) {
                    this.isRoundEnded = true;
                } else if (this.currentTime < this.startTime) {
                    this.isRoundYetToStart = true;
                    this.timeToStart = moment.duration(this.startTime - this.currentTime);
                } else {
                    if (!this.isDataFetched) {
                        this.getRoundTimings();
                        this.isDataFetched = true;
                    }
                    this.isRoundEnded = false;
                    this.isRoundYetToStart = false;
                    this.timeToEnd = moment.duration(this.endTime - this.currentTime);
                }
                this.isDataReady = true;
            }
            if (this.route.indexOf('/bidding-rounds/practice-round') === -1) {
                clearInterval(this.oneSecondTimer);
            }
        }, 1000);
    }
    ngOnDestroy() {
        clearInterval(this.oneSecondTimer);
        clearInterval(this.roundSettingsTimer);
    }

}
